module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-side-bar student-list no-padding"
  }, [_c('span', {
    staticClass: "tc b"
  }, [_vm._v(" Summary Reports ")]), _vm._v(" "), _c('div', {
    staticClass: "row middle-xs activity-list mt2",
    class: {
      activitySelected: _vm.summarySelected
    },
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('summarySelected')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart",
    staticStyle: {
      "margin-left": "2px"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.online_rts.length) ? _c('div', {
    staticClass: "tc",
    staticStyle: {
      "cursor": "default",
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "b",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v(" Written RoundTables ")]), _vm._v(" "), _c('div', {
    staticClass: "online_rt_activities mt3"
  }, [_vm._l((_vm.online_rts), function(activity, index) {
    return [_c('div', {
      key: index,
      staticClass: "row middle-xs activity-list",
      class: {
        activitySelected: _vm.isSelected(activity.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectActivity(activity)
        }
      }
    }, [_c('li', {
      staticClass: "col-xs-10 start-xs"
    }, [_c('p', {
      staticClass: "truncate-text"
    }, [_vm._v(_vm._s(activity.title))])])])]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.live_rts.length) ? _c('div', {
    staticClass: "tc",
    staticStyle: {
      "cursor": "default"
    }
  }, [_c('span', {
    staticClass: "b"
  }, [_vm._v(" Verbal RoundTables ")]), _vm._v(" "), _c('div', {
    staticClass: "live_rt_activities mt3"
  }, [_vm._l((_vm.live_rts), function(activity, index) {
    return [_c('div', {
      key: index,
      staticClass: "row middle-xs activity-list",
      class: {
        activitySelected: _vm.isSelected(activity.id)
      },
      on: {
        "click": function($event) {
          return _vm.selectActivity(activity)
        }
      }
    }, [_c('li', {
      staticClass: "col-xs-10 start-xs"
    }, [_c('p', {
      staticClass: "truncate-text"
    }, [_vm._v(_vm._s(activity.title))])])])]
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "col-xs-10 start-xs"
  }, [_c('p', {
    staticClass: "truncate-text"
  }, [_vm._v("Trending Reports")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5f0c97d3!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/studentActivitySummary/components/activitiesSideBar/activitiesSideBar.vue
// module id = 1691
// module chunks = 61